import { Component, OnInit } from '@angular/core';
import { faPencilAlt, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { MatDialog } from '@angular/material';
import { Rule } from 'src/app/models/rule.model';
import { RulesService } from 'src/app/services/rules/rules.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmComponent } from '../../dialogs/confirm/confirm.component';
import { RuleEngineService } from 'src/app/services/rule-engine/rule-engine.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rule-list',
  templateUrl: './rule-list.component.html',
  styleUrls: ['./rule-list.component.scss']
})
export class RuleListComponent implements OnInit {

  private _subConfirmDialog: any;

  public faPencilAlt = faPencilAlt;
  public faTrashAlt = faTrashAlt;
  public faPlus = faPlus;

  public notInProgress: boolean = false;
  public rules: Rule[];
  public sliderButtonStatus = false;

  constructor(private _matDialog: MatDialog, private _router: Router, private _rulesService: RulesService, private _toastr: ToastrService, private _ruleEngineService: RuleEngineService) { }

  ngOnInit() {
    this._getRuleEngineStatus();
    this._getRules();
  }

  private _getRuleEngineStatus() {
    this._ruleEngineService.get().subscribe(res => {
      if (res && res.length) {
        this.sliderButtonStatus = res[0]['status'];
      }
    });
  }

  private _getRules() {
    this.notInProgress = false;
    this._rulesService.get().subscribe(res => {
      if (res && res.length) {
        this.rules = res;
      }
      this.notInProgress = true;
    });
  }

  public onSliderChange(event) {
    this.sliderButtonStatus = event.checked;
    this._ruleEngineService.update(event.checked).subscribe(res => {

    }, err => {
      this.sliderButtonStatus = !this.sliderButtonStatus;
    });
  }

  public onDetail(id?: number) {
    if (id) {
      this._router.navigate(['/app/rules', id]);
    } else {
      this._router.navigate(['/app/rules', 'add-new']);
    }
  }

  onDelete(id: any) {
    this._subConfirmDialog = this._matDialog.open(ConfirmComponent, {
      width: '540px',
      disableClose: true
    }).afterClosed().subscribe(res => {
      if (res) {
        this._rulesService.delete(id).subscribe(res => {
          this._toastr.success('Rule deleted successfully.', '', { timeOut: 3000 });
          this.rules = this.rules.filter(obj => obj.id !== id);
        });
      }
      this._subConfirmDialog.unsubscribe();
    });
  }

}